import { createAPIActions } from '../../utils/redux-actions';

export const overpass = createAPIActions('OVERPASS');
